import heic2any from 'heic2any';

export const transformHeicFile = async (heicFileUrl: string) => {
    const blob = await fetch(heicFileUrl, { mode: 'cors' }).then((res) => res.blob());
    const result = await heic2any({ blob });
    return !Array.isArray(result) ? result : result[0];
};
